import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { QuestionSectionWrapper } from "../../../system/question/_layouts/item-wrapper";

type Props = {
	requiredPrepMillisecondBeforeDate: ForNodeType<number>;
	onSetRequiredPrepMillisecondBeforeDate: (input: string) => void;
	requiredPrepMillisecondBeforeDateOptions: FormOptionType[];

	requiredPrepMillisecondBeforeHour: ForNodeType<number>;
	onSetRequiredPrepMillisecondBeforeHour: (input: string) => void;
	requiredPrepMillisecondBeforeHourOptions: FormOptionType[];

	isEdited: boolean;
	hasError: boolean;

	title?: string;
	guide?: string;
};

export const QuestionRequiredPrepMilli = ({
	requiredPrepMillisecondBeforeDate,
	onSetRequiredPrepMillisecondBeforeDate,
	requiredPrepMillisecondBeforeDateOptions,

	requiredPrepMillisecondBeforeHour,
	onSetRequiredPrepMillisecondBeforeHour,
	requiredPrepMillisecondBeforeHourOptions,

	isEdited,
	hasError,

	title: _title,
	guide: _guide,
}: Props) => {
	const title = _title ?? "予約の締切日時";
	const guide =
		_guide ??
		"ゲストからの予約受付を締め切る日時を設定しましょう。<br />部屋やプランごとに個別に設定することも可能です。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>チェックイン日</p>
					<SelectField
						placeholder="選択"
						value={requiredPrepMillisecondBeforeDate.value}
						options={requiredPrepMillisecondBeforeDateOptions}
						handleValueChange={onSetRequiredPrepMillisecondBeforeDate}
						errorMessage={requiredPrepMillisecondBeforeDate.error}
					/>
					<p>の</p>
					<SelectField
						placeholder="選択"
						value={requiredPrepMillisecondBeforeHour.value}
						options={requiredPrepMillisecondBeforeHourOptions}
						handleValueChange={onSetRequiredPrepMillisecondBeforeHour}
						errorMessage={requiredPrepMillisecondBeforeHour.error}
					/>
					<p>で締め切る</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionRequiredPrepMilli.displayName = "QuestionRequiredPrepMilli";
